import { useEffect, type ReactNode } from 'react';
import { authStore, useAuth } from '../lib/auth';
import { EmailLogin, MfaEnroll, MfaVerify, ServerDown } from '../views/Login';

/* Nada do app aparece antes de a API confirmar a sessão (ou o modo local de desenvolvimento). */
export function AuthGate({ children }: { children: ReactNode }) {
  const auth = useAuth();

  useEffect(() => {
    authStore.refresh();
    const onRequired = () => { authStore.refresh(); };
    window.addEventListener('jm:auth-required', onRequired);
    return () => window.removeEventListener('jm:auth-required', onRequired);
  }, []);

  if (auth.phase === 'checking') return <div className="auth-page" aria-busy="true"><span className="sr-only">Verificando sessão…</span></div>;
  if (auth.phase === 'unreachable') return <ServerDown message={auth.message} />;
  switch (auth.state.status) {
    case 'signed_out': return <EmailLogin />;
    case 'mfa_enroll': return <MfaEnroll />;
    case 'mfa_verify': return <MfaVerify />;
    default: return <>{children}</>;
  }
}
